// Callable Cloud Functions — uses `functions` from firebase.js (anonymous Auth is enough).
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export function stripeCreatePaymentLinkCallable() {
  return httpsCallable(functions, "stripeCreatePaymentLink");
}

export function stripeCreateRefundCallable() {
  return httpsCallable(functions, "stripeCreateRefund");
}

export function marketingCreateLinkCallable() {
  return httpsCallable(functions, "marketingCreateLink");
}

export function marketingDeleteLinkCallable() {
  return httpsCallable(functions, "marketingDeleteLink");
}

export function marketingSyncAttributionCallable() {
  return httpsCallable(functions, "marketingSyncAttribution");
}

export function marketingProbePublicRoutingCallable() {
  return httpsCallable(functions, "marketingProbePublicRouting");
}

export function crmShellLoginCallable() {
  return httpsCallable(functions, "crmShellLogin");
}

export function crmBackfillAllProfileNamesCallable() {
  return httpsCallable(functions, "crmBackfillAllProfileNames");
}

export function crmLogFiamActivityCallable() {
  return httpsCallable(functions, "crmLogFiamActivity");
}

export function crmFetchGa4ClickAnalyticsCallable() {
  return httpsCallable(functions, "crmFetchGa4ClickAnalytics");
}

export function crmBackfillClickAnalyticsCallable() {
  return httpsCallable(functions, "crmBackfillClickAnalytics");
}

export function crmGetScanViewerDataCallable() {
  return httpsCallable(functions, "crmGetScanViewerData");
}

export function crmGetContactScansCallable() {
  return httpsCallable(functions, "crmGetContactScans");
}

export function crmGetScanDownloadManifestCallable() {
  return httpsCallable(functions, "crmGetScanDownloadManifest", { timeout: 120000 });
}

export function crmLogScanFileDownloadCallable() {
  return httpsCallable(functions, "crmLogScanFileDownload");
}
